import React from 'react';
import {tap, map} from 'rxjs/operators';

import ajax from 'iss/utils/ajax';
import subscribeTo from 'iss/utils/subscriptionUtils';

export const contractSupplierReviews = ajax.cache("/contract-supplier-reviews", 10 * ajax.MINUTES);

export function getContractSupplierReviews(contractSupplierId) {
  return ajax.getJson("/contract-supplier-reviews/supplier/"+contractSupplierId);
}

export function subscribeToContractSupplierReviews(WrappedComponent) {
  return function ContractSupplierReviewListPage({supplierId, ...props}) {
    let reviewsObservable = getContractSupplierReviews(supplierId);

    const SubscribedComponent = subscribeTo(reviewsObservable, 'reviews', WrappedComponent);

    return <SubscribedComponent supplierId={supplierId} {...props} />;
  };
}

export function getOwnContractSupplierReview(contractSupplierId) {
  return ajax.getJson("/contract-supplier-reviews/"+contractSupplierId+"/own").pipe(
    map(reviewArray => {
      return reviewArray.length > 0 ? reviewArray[0] : { id: null, created: null, grade: null, additionalInformation: null, party: null};
    })
  );
}

export function createContractSupplierReview(contractSupplierReviewCreateCommand) {
  return ajax.postJson("/contract-supplier-reviews", contractSupplierReviewCreateCommand)
    .pipe(tap(contractSupplierReviews.clearCache));
}

export function modifyContractSupplierReview(reviewId, contractSupplierReviewModifyCommand) {
  return ajax.putJson("/contract-supplier-reviews/"+reviewId, contractSupplierReviewModifyCommand)
    .pipe(tap(contractSupplierReviews.clearCache));
}


// WEBPACK FOOTER //
// ./modules/issFrontend/service/ContractSupplierReviewService.js